import React from 'react';
import PropTypes from 'prop-types';

import TaskNumber from './TaskNumber';
import TaskVolume from './TaskVolume';

import './TaskInfo.scss';

const TaskInfo = React.forwardRef(
  ({taskVolume, taskType, taskNumber, showTaskVolume, showTaskNumber, isHighlighted, labwareId}, ref) => (
    <div id={`task-info-${taskNumber}`} className="task-info" height="fit-content" width="fit-content">
      {showTaskVolume && <TaskVolume volume={taskVolume} type={taskType} />}
      {showTaskNumber && (
        <TaskNumber isHighlighted={isHighlighted} number={taskNumber} showArrow ref={ref} labwareId={labwareId} />
      )}
    </div>
  ),
);

TaskInfo.propTypes = {
  taskVolume: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  taskType: PropTypes.string,
  taskNumber: PropTypes.any,
  showTaskVolume: PropTypes.bool,
  showTaskNumber: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  labwareId: PropTypes.any,
};

TaskInfo.defaultProps = {
  taskVolume: 0,
  taskType: '',
  taskNumber: 0,
  showTaskVolume: false,
  showTaskNumber: false,
  isHighlighted: false,
  labwareId: '',
};

export default React.memo(TaskInfo);
